export class GoogleLoginModel {
  public idToken: string;
  public signupReason?: string;
}
